import { render, staticRenderFns } from "./CreatePackage.vue?vue&type=template&id=2cf2a4fa&scoped=true"
import script from "./CreatePackage.vue?vue&type=script&lang=js"
export * from "./CreatePackage.vue?vue&type=script&lang=js"
import style0 from "./CreatePackage.vue?vue&type=style&index=0&id=2cf2a4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2a4fa",
  null
  
)

export default component.exports